// function setSvgHeight() {
//   const svg = document.getElementById('exGpRui9Hwr1');
//   if (!svg) return;
  
//   // window.visualViewport dá o tamanho real visível (mais preciso que innerHeight no Safari)
//   const height = window.visualViewport 
//     ? window.visualViewport.height 
//     : window.innerHeight;

// 	console.log('window.visualViewport', window.visualViewport );
// 	console.log('window.visualViewport.height', window.visualViewport.height );
// 	console.log('window.innerHeight', window.innerHeight );
// 	console.log('window', window );

    
//   svg.style.height = `900px`;
// }

// setSvgHeight();

// Atualiza quando o teclado/barra do Safari muda o viewport
// if (window.visualViewport) {
//   window.visualViewport.addEventListener('resize', setSvgHeight);
// } else {
//   window.addEventListener('resize', setSvgHeight);
// }





var menu_height = jQuery('.nav').outerHeight(); // use on window resize
var scrollTop = 0;
var lastScrollTop = 0;
var hide_on_scroll_down = false;



jQuery(document).ready(function() {

	// removeHomeSvgAfterDelay();

	/*
	 * Hamburger menu
	*/
	jQuery('#nav-icon, #nav-icon-inside').click(function(){
		jQuery('body').toggleClass('menu-open');
		jQuery('#nav-icon, #nav-icon-inside').toggleClass('open');
		jQuery('.nav').toggleClass('open');
		jQuery('.nav__invisibleMenuContainer').toggleClass('open');
		// To-do: prevent scroll on the page
	});

	jQuery('.nav__invisibleMenuContainer').on('click', function(e) {
		if (jQuery(e.target).closest('.container').length === 0) {
			jQuery('body').removeClass('menu-open');
			jQuery('#nav-icon, #nav-icon-inside').removeClass('open');
			jQuery('.nav').removeClass('open');
			jQuery('.nav__invisibleMenuContainer').removeClass('open');
		}
	});

	// Prevent overlay click when interacting with the inner container
	jQuery('.nav__invisibleMenuContainer .container').on('click', function(e){
		e.stopPropagation();
	});

	/**
	 * Menu Sticky
	*/
	handleNav();


	/**
	 * Prevent Portfolio link
	*/
	jQuery('.no-link > a').click(function(event) {
		event.preventDefault();
	});


	/**
	* Correct menu height in iOS
	*/
	appHeight();



});



jQuery(window).scroll(function(event) {

	/**
	 * Menu Sticky
	*/
	handleNav();

	/**
	* Correct menu height in iOS
	*/
	appHeight();

});

jQuery(window).resize(function(event) {

	/**
	 * Menu Sticky
	*/
	handleNav();

	/**
	* Correct menu height in iOS
	*/
	appHeight();



});



/**
* Functions
*/
function removeHomeSvgAfterDelay() {
	if (!jQuery('body').hasClass('home')) {
		return;
	}

	setTimeout(function() {
		var svg = document.querySelector('#exGpRui9Hwr1');
		if (svg) {
			svg.remove();
		}
	}, 3000);
}

function appHeight() {
	const doc = document.documentElement;
	doc.style.setProperty('--app-height', `${window.innerHeight}px`);
	doc.style.setProperty('--nav-height', `${jQuery('.nav').outerHeight()}px`);
	doc.style.setProperty('--wpadmin-height', `${jQuery('#wpadminbar').outerHeight()}px`);
}

function handleNav() {
	/*
	 * Show/hide sidebar - quick links in mobile
	 * Show/hide nav in mobile
	*/
	scrollTop = jQuery(window).scrollTop();
	menu_height = jQuery('.nav').outerHeight();
	if (scrollTop < menu_height) {
		jQuery('.nav').addClass('sticky');
	} else {
		if ( hide_on_scroll_down ) {
			if (scrollTop > lastScrollTop){
			   // downscroll code
			   jQuery('.nav').removeClass('sticky');
			} else {
			  // upscroll code
			  jQuery('.nav').addClass('sticky');
			}
		} else {
			jQuery('.nav').removeClass('sticky');
		}
	}
	lastScrollTop = scrollTop;
}